module.exports = __webpack_public_path__ + "static/img/img_bg.580b7cc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/dali/img_bg.png
// module id = 1RPa
// module chunks = 19